import React from 'react';
import s from './style.module.css';
import { PriceTableProps, MemberShipProps } from '../../../props';
import { priceFormat } from '@Util/util';
import PriceVersionNote from '@Pages/Detail/components/price_version_note/view';

const SellingPriceTable = (props: MemberShipProps) => {
    const displayedMemberships = props.memberships.filter((membership) => !membership.isInitialOffering);

    return (
        <>
            <table className={s.price_table}>
                <tbody>
                    {displayedMemberships.map((membership) => (
                        <PriceTable key={`memberships-${membership.id}`} membership={membership} isJpy={props.isJpy} />
                    ))}
                </tbody>
            </table>
            <PriceVersionNote memberships={displayedMemberships} />
        </>
    );
};

export default SellingPriceTable;

export const PriceTable = (props: PriceTableProps) => {
    const membership = props.membership;
    const priceUnit = props.isJpy ? '万円' : 'THB';
    return (
        <>
            <tr>
                <th>会員種別</th>
                <th>
                    買希望最高値<span className={s.price_table_supplement || '-'}>（件数）</span>
                </th>
            </tr>
            <tr>
                <td>{membership.name || membership.membershipType || '-'}</td>
                <td>
                    {membership.isAsk ? 'ご相談' : priceFormat(membership.buyingPrice, priceUnit)}
                    <span className={s.price_table_supplement}>（{membership.numberOfBuyingOffers}件）</span>
                </td>
            </tr>
        </>
    );
};
